export const handleNumberChange = (value: string, isInt?: boolean) => {
  const valueWithoutDots = isInt ? value.replace(/\./g, "") : value;

  const filteredValue = valueWithoutDots
    .replace(/[^0-9.+-]/g, "")
    .replace(/0-/g, "-")
    .replace(/^([+-])0+(\d)/, "$1$2")
    .replace(/^0{2,}(\.\d*)$/, "0$1")
    .replace(/^0(\d)(?!\.)/, "$1")
    .replace(/([+-])[+-]+/g, "$1");

  if (!filteredValue) {
    return 0;
  }

  if (filteredValue.length >= 2 && filteredValue.includes(".")) {
    return value;
  }

  return filteredValue;
};
